module.exports = __webpack_public_path__ + "static/media/Adding_IF_fees_and_charges_V1.c5a06fa7.mp4";